import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { Visit, CreateVisitDto } from '../types/visit.types';
import { VisitFileDto } from '../types/api.types';

export const visitsApi = {
  getById: async (id: number): Promise<Visit> => {
    const response = await apiClient.get<Visit>(API_ENDPOINTS.VISIT_BY_ID(id));
    return response.data;
  },

  getByPatientId: async (patientId: number): Promise<Visit[]> => {
    const response = await apiClient.get<Visit[]>(API_ENDPOINTS.VISITS_BY_PATIENT(patientId));
    return response.data;
  },

  create: async (data: CreateVisitDto): Promise<Visit> => {
    const formData = new FormData();
    formData.append('PatientId', data.patientId.toString());
    formData.append('VisitDate', data.visitDate);
    if (data.diagnosis && data.diagnosis.trim() !== '') {
      formData.append('Diagnosis', data.diagnosis);
    }
    // Always append Notes if provided (even if empty, to ensure it's sent)
    if (data.notes !== undefined && data.notes !== null) {
      formData.append('Notes', data.notes.trim());
    }
    if (data.doctorId) {
      formData.append('DoctorId', data.doctorId.toString());
    }

    // Files are optional - only append if files exist
    if (data.files && data.files.length > 0) {
      data.files.forEach(file => {
        formData.append('files', file);
      });
    }

    const response = await apiClient.post<Visit>(API_ENDPOINTS.VISITS, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getVisitFiles: async (visitId: number): Promise<VisitFileDto[]> => {
    const response = await apiClient.get<VisitFileDto[]>(API_ENDPOINTS.VISIT_FILES(visitId));
    return response.data;
  },

  getAllVisitFiles: async (patientId: number): Promise<VisitFileDto[]> => {
    const response = await apiClient.get<VisitFileDto[]>(API_ENDPOINTS.ALL_VISIT_FILES(patientId));
    return response.data;
  },

  deleteVisitFile: async (fileId: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.VISIT_FILE_DELETE(fileId));
  },
};

